import { createAccountUsersAccountsPath, newLookContinueWithoutAccountPath } from "src/routes";
import { submitRequiringPhoneVerification } from "src/customer/phone_verified_submission";

const createAccount = (formData: FormData) => submitRequiringPhoneVerification(createAccountUsersAccountsPath(), formData);
const continueWithoutAccount = (formData: FormData) => submitRequiringPhoneVerification(newLookContinueWithoutAccountPath(), formData)

export { continueWithoutAccount, createAccount }
